import { quoteTone } from '@/utils/quoteColors'
const numeric = value => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) ? Number(value) : null
const money = value => numeric(value) === null ? '--' : Number(value).toFixed(2)
const percent = (value, scale = 1) => numeric(value) === null ? '--' : `${Number((Number(value) * scale).toFixed(2))}%`
const difference = (a, b) => numeric(a) === null || numeric(b) === null ? null : Number(a) - Number(b)

export function dateTime(value) {
  if (value === null || value === undefined || value === '') return '--'
  // API timestamps are Unix seconds; render in the market's Shanghai/Hong Kong time zone.
  if (!/^\d+$/.test(String(value))) return String(value)
  const date = new Date(Number(value) * (String(value).length <= 10 ? 1000 : 1) + 8 * 3600000)
  return Number.isNaN(date.getTime()) ? '--' : date.toISOString().slice(0, 19).replace('T', ' ')
}

export function contractDetails(market, info) {
  const hk = market === 'hk' || market === 'us'
  const capital = info.capital || {}
  const total = hk ? info.contract_total_money : capital.consultMoney
  const profit = hk ? info.floatPL : capital.floatPL
  const deposit = hk ? info.deposit_money : info.deposit
  const warn = hk ? info.stop_loss_money : info.loss_warn
  const close = hk ? info.close_position_money : info.loss_close
  const deposits = [deposit, info.append_deposit, info.expand_deposit]
  const principal = deposits.every(value => numeric(value) !== null) ? deposits.reduce((sum, value) => sum + Number(value), 0) : 0
  const rows = [
    ['合约总值', money(total)],
    ['操盘资金', money(hk ? info.trading_money : info.account_money)],
    ['浮动盈亏', money(profit), false, quoteTone(profit)],
    ['盈亏率', principal > 0 && numeric(profit) !== null ? percent(Number(profit) / principal, 100) : '--', false, principal > 0 ? quoteTone(profit) : ''],
    ['累计提盈', money(hk ? info.withdraw_profit : info.profits)],
    ['持仓市值', money(hk ? info.marketValue : capital.marketValue)],
    ['可用余额', money(info.available_money)],
    ['亏损预警线', money(warn)],
    ['亏损强平线', money(close)],
    ['起始保证金', money(deposit)],
    ['扩大保证金', money(info.expand_deposit)],
    ['追加保证金', money(info.append_deposit)],
    ['总配资金额', money(hk ? info.allocation_money : info.funding)],
    ['利率利息', percent(info.ratio)],
    ['累计利息', money(hk ? info.interest_money : info.interest)],
    ['利润分成', percent(info.point, 100)],
    ['买入冻结', money(hk ? info.blocked_money : capital.blockedMoney)],
    ['合约净资产', money(hk ? info.contract_net_value : info.consult_net_value)],
    ['距离亏损预警线', money(difference(total, warn)), false, 'red'],
    ['距离亏损强平线', money(difference(total, close)), false, 'red'],
    ['个股仓位限制', percent(info.position_limit, 100)],
    ['合约时间', `${dateTime(hk ? info.begin_time : info.atime)} 至 ${dateTime(hk ? info.end_time : info.etime)}`, true],
    ['合约编号', (hk ? info.contract_id : info.contact_id) || '--', true],
    ['股票累计分红', money(hk ? info.cash_dividend_money : info.cash_dividend)],
    ['合约状态', info.status == null ? '--' : ({ 0: '自动存续', 1: '已结算', 2: '已删除', 3: '已取消' }[info.status] || '--')]
  ]
  return rows.map(([label, value, wide, tone]) => ({ label, value, wide: !!wide, tone }))
}
